fragment SearchIndexFull on SearchIndex {
  searchIndex
}
